<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lan_greidslufrest_umsokn_step4_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            :disabled="disable"
            v-model="umsokn.reason"
            :label="t('lan_greidslufrest_umsokn_step4_astaeda')"
            :placeholder="t('lan_greidslufrest_umsokn_step4_astaeda')"
            variant="outlined"
            rows="5"
            auto-grow
          />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

type Umsokn = {
  reason?: string
} & Record<string, any>

const props = defineProps<{
  umsokn: Umsokn
  disable?: boolean
}>()

const { t } = useI18n()

// alias for template
const umsokn = props.umsokn
const disable = props.disable ?? false
</script>

<style scoped>
.forms__header {
  font-weight: 700;
  margin-bottom: 16px;
}
</style>
